module.exports = __webpack_public_path__ + "img/bg2@2x.073e47c5.png";